import jsPDF from 'jspdf';

export const generatePriceListPDF = (equipment, companySettings = {}) => {
  const doc = new jsPDF('p', 'mm', 'a4');
  const pageWidth = doc.internal.pageSize.getWidth();
  const pageHeight = doc.internal.pageSize.getHeight();
  const margin = 15;
  const contentWidth = pageWidth - (margin * 2);
  const primaryColor = [75, 42, 130];
  const grayColor = [100, 100, 100];
  const lightGray = [240, 240, 240];
  let yPos = margin;

  const checkNewPage = (neededSpace = 20) => {
    if (yPos + neededSpace > pageHeight - 25) {
      doc.addPage();
      yPos = margin + 20;
      return true;
    }
    return false;
  };

  const addPageHeader = () => {
    doc.setFillColor(...primaryColor);
    doc.rect(0, 0, pageWidth, 15, 'F');
    doc.setTextColor(255, 255, 255);
    doc.setFontSize(10);
    doc.setFont('helvetica', 'bold');
    doc.text('PRIJSLIJST VERHUUR', margin, 10);
    doc.setFontSize(8);
    doc.text(companySettings.name || 'Van Vessem Sound & Lights', pageWidth - margin, 10, { align: 'right' });
  };

  // Groepeer op hoofdcategorie en subcategorie
  const groupedEquipment = {};
  equipment.forEach(item => {
    const category = item.category || 'Overig';
    const subcategory = item.subcategory || '';
    if (!groupedEquipment[category]) groupedEquipment[category] = {};
    if (!groupedEquipment[category][subcategory]) groupedEquipment[category][subcategory] = [];
    groupedEquipment[category][subcategory].push(item);
  });
  const sortedCategories = Object.keys(groupedEquipment).sort();

  // Track pagina's voor index
  const pageTracker = {};
  
  // === STAP 1: Render content eerst (vanaf pagina 2) ===
  doc.addPage(); // Pagina 2 = start content
  yPos = margin;
  addPageHeader();
  yPos = 25;

  sortedCategories.forEach((category) => {
    checkNewPage(30);
    pageTracker[category] = { page: doc.internal.getNumberOfPages(), subcategories: {} };
    
    // Hoofdcategorie header
    doc.setFillColor(...primaryColor);
    doc.rect(margin, yPos - 5, contentWidth, 10, 'F');
    doc.setTextColor(255, 255, 255);
    doc.setFontSize(12);
    doc.setFont('helvetica', 'bold');
    doc.text(category.toUpperCase(), margin + 3, yPos + 2);
    yPos += 15;

    const sortedSubcategories = Object.keys(groupedEquipment[category]).sort();
    sortedSubcategories.forEach((subcategory) => {
      if (subcategory) {
        checkNewPage(25);
        pageTracker[category].subcategories[subcategory] = doc.internal.getNumberOfPages();
        doc.setFillColor(220, 220, 240);
        doc.rect(margin, yPos - 4, contentWidth, 7, 'F');
        doc.setTextColor(...primaryColor);
        doc.setFontSize(10);
        doc.setFont('helvetica', 'bold');
        doc.text(subcategory, margin + 5, yPos);
        yPos += 10;
      } else {
        pageTracker[category].subcategories[''] = doc.internal.getNumberOfPages();
      }

      // Tabel header
      doc.setFillColor(...lightGray);
      doc.rect(margin, yPos - 4, contentWidth, 8, 'F');
      doc.setTextColor(0, 0, 0);
      doc.setFontSize(9);
      doc.setFont('helvetica', 'bold');
      doc.text('Artikelcode', margin + 3, yPos);
      doc.text('Omschrijving', margin + 40, yPos);
      doc.text('Prijs/dag', pageWidth - margin - 3, yPos, { align: 'right' });
      yPos += 8;
      doc.setFont('helvetica', 'normal');

      // Items
      const items = groupedEquipment[category][subcategory].sort((a, b) => 
        (a.serialNumber || "").localeCompare(b.serialNumber || "")
      );
      items.forEach((item, index) => {
        checkNewPage(8);
        if (index % 2 === 0) {
          doc.setFillColor(250, 250, 250);
          doc.rect(margin, yPos - 4, contentWidth, 7, 'F');
        }
        doc.setTextColor(0, 0, 0);
        doc.setFontSize(8);
        const code = item.serialNumber || '-';
        doc.text(code.substring(0, 15), margin + 3, yPos);
        let description = item.name || 'Geen naam';
        if (description.length > 50) description = description.substring(0, 47) + '...';
        doc.text(description, margin + 40, yPos);
        const price = item.price ? `€ ${parseFloat(item.price).toFixed(2)}` : '€ 0.00';
        doc.text(price, pageWidth - margin - 3, yPos, { align: 'right' });
        yPos += 7;
      });
      yPos += 8;
    });
    yPos += 5;
  });

  // === STAP 2: Ga terug naar pagina 1 voor index ===
  doc.setPage(1);
  yPos = margin;

  // Logo en titel
  if (companySettings.logo) {
    try {
      doc.addImage(companySettings.logo, 'PNG', margin, yPos, 50, 28);
    } catch (e) { console.log('Logo error'); }
  }
  
  doc.setTextColor(...primaryColor);
  doc.setFontSize(24);
  doc.setFont('helvetica', 'bold');
  doc.text('Prijslijst Verhuur', companySettings.logo ? margin + 55 : margin, yPos + 15);
  doc.setFontSize(11);
  doc.setFont('helvetica', 'normal');
  doc.setTextColor(...grayColor);
  doc.text(companySettings.name || 'Van Vessem Sound & Lights', companySettings.logo ? margin + 55 : margin, yPos + 22);
  yPos += 40;

  // Index titel
  doc.setFontSize(14);
  doc.setFont('helvetica', 'bold');
  doc.setTextColor(...primaryColor);
  doc.text('Index', margin, yPos);
  yPos += 10;

  // Index met juiste paginanummers
  doc.setFontSize(10);
  sortedCategories.forEach((category, idx) => {
    // Hoofdcategorie
    doc.setFont('helvetica', 'bold');
    doc.setTextColor(...primaryColor);
    const catPage = pageTracker[category].page;
    doc.text(`${idx + 1}. ${category}`, margin + 3, yPos);
    doc.setTextColor(100, 100, 100);
    doc.text(`${catPage}`, pageWidth - margin - 5, yPos, { align: 'right' });
    yPos += 6;

    // Subcategorieën
    const sortedSubs = Object.keys(groupedEquipment[category]).sort();
    sortedSubs.forEach((sub) => {
      if (sub) {
        doc.setFont('helvetica', 'normal');
        doc.setTextColor(0, 0, 0);
        const subPage = pageTracker[category].subcategories[sub];
        doc.text(`    ${sub}`, margin + 8, yPos);
        doc.setTextColor(100, 100, 100);
        doc.text(`${subPage}`, pageWidth - margin - 5, yPos, { align: 'right' });
        yPos += 5;
      }
    });
    yPos += 2;
  });

  // Footer op alle pagina's
  const pageCount = doc.internal.getNumberOfPages();
  for (let i = 1; i <= pageCount; i++) {
    doc.setPage(i);
    doc.setFontSize(8);
    doc.setTextColor(...grayColor);
    const date = new Date().toLocaleDateString('nl-NL');
    doc.text(`${companySettings.name || 'Van Vessem Sound & Lights'} | Prijslijst ${date}`, pageWidth / 2, pageHeight - 10, { align: 'center' });
    doc.text(`Pagina ${i} van ${pageCount}`, pageWidth - margin, pageHeight - 10, { align: 'right' });
  }

  return doc;
};
